import { KuposDatePicker, KuposSelectBox } from '../../../common';

import DateService from '../../../../services/dateService';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { useEffect } from 'react';
import { useState } from 'react';
import { withTranslation } from 'react-i18next';

function RenderPasajebusInputs({
  t,
  transferSourceCityError,
  setTransferSourceCityError,
  setSelect1,
  setSelect2,
  selectOptions,
  selectSourceCity,
  onSourceChange,
  onInputChange,
  sourcePlaceholder,
  sourceCityError,
  getOriginSelectedFilteredDestinations,
  selectOptions2,
  selectDestinationCity,
  onDestinationChange,
  onInputChange2,
  destinationPlaceholder,
  destinationCityError,
  onwardDate,
  onwardDateChange,
  dateError,
  returnDate,
  returnDateChange,
  dateErrorReturn,
  search,
  destinationRef,
  home,
}) {
  transferSourceCityError ? setTransferSourceCityError(null) : null;

  const [maximumBookingDate, setMaximumBookingDate] = useState(45);

  useEffect(() => {
    setMaximumBookingDate(
      home &&
        home.metaData &&
        home.metaData.maximum_booking_date &&
        home.metaData.maximum_booking_date
        ? home.metaData.maximum_booking_date
        : 45,
    );
  }, [home]);

  return (
    <form onSubmit={search}>
      <div className="home-selection-input-boxes">
        <div className="home-selection-input-box font10">
          <span className="label bold-text margin-B5 d-inline-block" style={{ fontSize: '13px' }}>
            {t('HOME.ORIGIN')}
          </span>
          <KuposSelectBox
            reactSelect
            selectType="origin"
            ref={instance => {
              setSelect1(instance);
            }}
            options={selectOptions}
            selectedOption={selectSourceCity}
            onChange={onSourceChange}
            onInputChange={onInputChange}
            icon="/images/search-bar/search-bar-origin.svg"
            hideArrow={true}
            error={sourceCityError ? true : false}
            errorMessage={t(sourceCityError)}
            placeholder={sourcePlaceholder || t('HOME.ORIGIN')}
            height={40}
            t={t}
          />
        </div>

        <div className="home-selection-input-box font10">
          <span className="label bold-text margin-B5 d-inline-block" style={{ fontSize: '13px' }}>
            {t('HOME.DESTINATION')}
          </span>
          <KuposSelectBox
            reactSelect
            selectRef={destinationRef}
            selectType="destination"
            ref={instance => {
              // select2 = instance;
              setSelect2(instance);
            }}
            options={
              selectSourceCity
                ? getOriginSelectedFilteredDestinations(selectOptions2, selectSourceCity)
                : null
            }
            selectedOption={selectDestinationCity}
            onChange={onDestinationChange}
            onInputChange={onInputChange2}
            icon="/images/search-bar/search-bar-destination.svg"
            hideArrow={true}
            error={destinationCityError ? true : false}
            errorMessage={t(destinationCityError)}
            placeholder={destinationPlaceholder || t('HOME.DESTINATION')}
            height={40}
            t={t}
          />
        </div>

        <div className="home-selection-input-box datebox" style={{ flex: home.is_mot ? 1 : 0 }}>
          <span className="label bold-text margin-B5 " style={{ fontSize: '13px' }}>
            {t('HOME.ONE_WAY')}
          </span>
          <KuposDatePicker
            selectedDate={onwardDate}
            onDateChange={date => onwardDateChange(date)}
            minDate={DateService.getTodayString()}
            maxDate={moment()
              .add(maximumBookingDate ? maximumBookingDate : 5, 'days')
              .format('DD-MM-YYYY')}
            error={dateError ? true : false}
            errorMessage={dateError}
            placeholder={t('HOME.SELECT_DATE')}
            t={t}
          />
        </div>
        {home.is_mot ? null : (
          <div className="home-selection-input-box font10 datebox">
            <span className="label bold-text margin-B5 d-inline-block" style={{ fontSize: '13px' }}>
              {t('HOME.ROUND_TRIP')}
            </span>
            <KuposDatePicker
              selectedDate={returnDate}
              onDateChange={date => returnDateChange(date)}
              minDate={onwardDate}
              maxDate={moment()
                .add(maximumBookingDate ? maximumBookingDate : 5, 'days')
                .format('DD-MM-YYYY')}
              placeholder={t('HOME.OPTIONAL_DATE')}
              error={dateErrorReturn ? true : false}
              errorMessage={dateErrorReturn}
              canEraseDate={true}
              t={t}
            />
            {returnDate && (
              <img
                className="pointer"
                onClick={() => returnDateChange('')}
                src={'/images/search-bar/SearchBar-XMark.svg'}
                style={{
                  width: 12,
                  height: 12,
                  resizeMode: 'contain',
                  position: 'absolute',
                  right: 7,
                  bottom: 18,
                }}
                alt=""
              />
            )}
          </div>
        )}

        <div className="home-selection-input-box font12 datebox mt-1">
          <button
            className="kupos-button home-selection-input-button "
            onClick={search}
            type="onSubmit"
          >
            <img
              className="icon-size"
              src="/images/icons/home/icon_search-white.png"
              alt={t('TRANSLATIONS.ICON_SEARCH_WHITE')}
            />{' '}
            <span>{t('HOME.SEARCH')}</span>
          </button>
        </div>
      </div>
    </form>
  );
}

function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

export default connect(mapStateToProps)(withTranslation('common')(RenderPasajebusInputs));



// WEBPACK FOOTER //
// ./src/features/home/HomeSearchBoxPB/RenderPasajebusInputs/RenderPasajebusInputs.js